import SocialMediaInfo from './SocialMediaInfo';

export default SocialMediaInfo;
